<template>
  <v-container v-if="authPermissions.has('store_balances:view')">
    <v-card>
      <div class="pa-2">
        <v-data-table :headers="headers" :items="storeBalanceItems">
          <template v-slot:item.collectible="{ value }">
            {{ formatAccounting(value) }}
          </template>
          <template v-slot:item.payable="{ value }">
            {{ formatAccounting(value) }}
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import appAxios from '../../../extra-functions/axios.extra'
import { formatAccounting } from '@/lib/utils'

export default {
  name: 'StoreBalance',
  data() {
    return {
      storeBalanceLoading: false,
      storeBalanceItems: [],
      headers: [
        { text: 'Store', value: 'store' },
        { text: 'Collectible', value: 'collectible' },
        { text: 'Payable', value: 'payable' },
      ],
    }
  },
  computed: {
    ...mapState({
      storeId: state => state.settings.storeId,
      token: state => state.auth.token,
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  created() {
    this.getBalances()
  },
  methods: {
    async getBalances() {
      try {
        const axios = appAxios(this.token)
        if (this.storeBalanceLoading) return
        this.storeBalanceLoading = true
        const { data } = await axios.get('/stores/transfer-balances')
        this.storeBalanceItems = data
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
        // setTimeout(() => this.getBalances(), 5000)
      } finally {
        this.storeBalanceLoading = false
      }
    },
    formatAccounting,
  },
}
</script>
